import React from 'react';
import { ShowIf } from 'components/utils';
import { Link } from 'react-router';
import ReactPaginate from 'react-paginate';
import {LoadingDataTale} from 'modules/thanh-tra/datatable';

export default class DataTableMultipleSelect extends React.Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
      export: 'btn-green tt-export',
      userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {}
    };

  }

  handleChangePageSize(size) {
    if (this.props.parent && this.props.parent.handleChangePageSize) {
      this.props.parent.handleChangePageSize.bind(this.props.parent, size);
    }
  }

  handlePageClick(page) {
    if (this.props.parent && this.props.parent.handlePageClick) {
      this.props.parent.handlePageClick.bind(this.props.parent, page);
    }
  }

  onCheck() {
    this.props.onCheck();
  }

  render() {
    let pageNumber = this.props.pageData ? this.props.pageData.number : 0;
    let pageSize = this.props.pageData ? this.props.pageData.size : 0;

    let dataListItem = this.props.dataList.map((item, i) => {
      return (
        React.cloneElement(this.props.children, {
        key: i,
        count: (pageNumber * pageSize) + i + 1,
        item,
        parent: this.props.parent
      }))
    });
    return (
      <div className='wrapper-table'>
        <div className="table-container">
          <table className="table-content">
            <thead className="table-header">
              <tr>
                <th className="table-header-col table-checkbox" style={{width: 40}}>
                  <ShowIf condition={this.props.onDisableCheck !== true}>
                    <label className="pt-control pt-checkbox pt-large">
                      <input type="checkbox" className="pt-large" name="" onChange={this.onCheck.bind(this)} checked={this.props.selectAllStatus}/>
                      <span className="pt-control-indicator"></span>
                    </label>
                  </ShowIf>
                </th>
                { this.props.header.map((item, i) => {
                    return (
                      <th key={ i } className={ "table-header-col " + (item.className ? item.className : '') } colSpan={ item.colSpan } style={ { width: item.width, minWidth: item.minWidth } }>
                        { item.name }
                      </th>
                      );
                  }) }
              </tr>
            </thead>
            { this.props.tableLoading ? (
              <tbody className="table-body">
                <tr className="table-loading">
                  <LoadingDataTale countLoading={12} colSpan={!this.props.ThongKeBaoCao ? this.props.header.length + 1 : this.props.numberColumnHeader}/>
                </tr>
              </tbody>
              ) : (
              <tbody className="table-body">
                { dataListItem }

                  { !this.props.dataList.length && !this.props.showAddMore? (this.props.search ?
                      (
                      <ShowIf condition={!this.props.ThongKeBaoCao}>
                        <tr>
                          <td colSpan={ this.props.header.length + 1 }>Không có dữ liệu</td>
                        </tr>
                      </ShowIf>
                      ) : (
                      <ShowIf condition={!this.props.ThongKeBaoCao}>
                        <tr>
                          <td colSpan={ this.props.header.length + 1 }>Chưa có dữ liệu</td>
                        </tr>
                      </ShowIf>
                    )) : null
                  }
                  { !this.props.dataList.length && !this.props.showAddMore? (this.props.search ?
                      (
                      <ShowIf condition={this.props.ThongKeBaoCao}>
                        <tr>
                          <td colSpan={ this.props.numberColumnHeader }>Không có dữ liệu</td>
                        </tr>
                      </ShowIf>
                      ) : (
                      <ShowIf condition={this.props.ThongKeBaoCao}>
                        <tr>
                          <td colSpan={ this.props.numberColumnHeader }>Chưa có dữ liệu</td>
                        </tr>
                      </ShowIf>
                    )) : null
                  }
              </tbody>
              ) }
          </table>
          { !this.props.hidePagination && this.props.dataList.length>0 && !this.props.ThongKeBaoCao ? (
            <div className="pagination-wrap">
              { (this.props.pageData && this.props.pageData.totalElements && this.props.pageData.totalElements > this.props.pageData.size) ?
                <ReactPaginate
                  pageCount={ this.props.pageData ? this.props.pageData.totalPages : 1 }
                  marginPagesDisplayed={ 1 } pageRangeDisplayed={ 2 } previousLabel={ "<" } nextLabel={ ">" }
                  breakLabel={ <a href="javascript:void(0)">...</a> } breakClassName={ "item" }
                  onPageChange={ this.props.parent.handlePageClick.bind(this.props.parent) }
                  containerClassName={ "pagination-list" } pageClassName={ 'item' }
                  subContainerClassName={ "pages pagination" } previousClassName={ 'item' }
                  nextClassName={ 'item' } activeClassName={ "active" }
                  forcePage={ this.props.pageData ? this.props.pageData.number : 0 } />
                : null }
              {`(${(pageNumber * pageSize) + 1}-${pageNumber == 0 ? this.props.pageData.totalElements : (pageNumber+1)*pageSize}/${this.props.pageData.totalElements}) Trên 1 trang: `}
              <Link className={ this.props.pageData.size == 10 ? 'disable-page' : 'page-number' } onClick={ this.props.parent.handleChangePageSize.bind(this.props.parent, 10) }>10</Link>,
              <Link className={ this.props.pageData.size == 25 ? 'disable-page' : 'page-number' } onClick={ this.props.parent.handleChangePageSize.bind(this.props.parent, 25) }>25</Link>,
              <Link className={ this.props.pageData.size == 50 ? 'disable-page' : 'page-number' } onClick={ this.props.parent.handleChangePageSize.bind(this.props.parent, 50) }>50</Link>
            </div>
            ) : null }
        </div>
      </div>
      );
  }
}
DataTableMultipleSelect.defaultProps = {
  type: 'THUONG_XUYEN',
  labelPagination: 'Số hồ sơ',
  showAddMore: false,
  typeExport: 'TIEP_CONG_DAN',
  ThongKeBaoCao: false,
  header: [],
  selectAll: false,
  dataList: []
}



// WEBPACK FOOTER //
// ./src/components/modules/thanh-tra/datatable/DataTableMultipleSelect.jsx